module.exports = __webpack_public_path__ + "static/media/Theon Greyjoy 1.cb0c85e2.jpg";